import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

import ServiceGroup from './components/serviceGroup';
import { ButtonLight, GroupOverlayCenter, GroupOverlayInner } from './components/css';
import AddSVG from './assets/svg/add';
import request, { apiHost } from '../../../utils/request';
import {
  saveCategory,
  saveQuestion,
  saveSchemaToDB,
  saveService
} from './components/saveSchemaToDB';

import ValidateLoader from '../../../UI/validateLoader';

export default function ManagedITService() {
  const [fullyManagedAdminData, setFullyManagedAdminData] = useState([]);
  const [isLoading,setIsLoading] = useState(true);
  const [offeringId, setOfferingId] = useState(null);
  const [savingData,setSavingData] = useState(false);

  const sortByIdxRecursively = (data) => {
    if (Array.isArray(data)) {
      // Sort the array by the 'ord' key if present
      data.sort((a, b) => (a.ord !== undefined ? a.ord : Infinity) - (b.ord !== undefined ? b.ord : Infinity));
      // Recursively process each element of the array
      data.forEach(sortByIdxRecursively);
    } else if (data && typeof data === 'object') {
      // If it's an object, process each key
      Object.values(data).forEach(sortByIdxRecursively);
    }
  };
    
  const saveFullyManagedState = data => {
    setOfferingId(data[0].id);
    const myData = data[0].productCatalogServiceGroups;
    sortByIdxRecursively(myData);
    setFullyManagedAdminData(myData);
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await request.get('/productCatalog');
        saveFullyManagedState(response.data[0].productCatalogOfferings);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
      finally{
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const [unsavedChanges, setUnsavedChanges] = useState(false);

  const handleAddCategory = () => {
    const clonedAdminData = JSON.parse(JSON.stringify(fullyManagedAdminData));

    clonedAdminData.push({
      id: '',
      name: '',
      isSaved: false,
      ServicesInGroup: [
        {
          offeringId: '',
          groupId: '',
          id: '', //ServiceId
          name: '',
          productCatalogQuantities: [
            {
              serviceId: '',
              id: '',
              isRequired: false,
              name: ''
            }
          ],
          isSaved: false,
          isRequired: false,
          productCatalogQuestions: [
            {
              offeringId: '',
              serviceId: '',
              id: '', //questionId
              name: '',
              note: '',
              isSaved: false,
              isRequired: false,
              productCatalogOptions: [
                {
                  questionId: '',
                  id: '', //optionId
                  name: '',
                  productCatalogPricings: [
                    {
                      id: '',
                      optionId: '',
                      cost: 0,
                      onetimePrice: 0,
                      costPremium: 0,
                      onetimePricePremium: 0,
                      operationType: 'ADD'
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    });
    setFullyManagedAdminData(clonedAdminData);
  };

  // Check if there are unsaved changes
  const hasUnsavedChanges = () => {
    return fullyManagedAdminData.some(
      category =>
        !category.isSaved ||
        category.ServicesInGroup.some(service => !service.isSaved)
    );
  };

  // Handle page unload
  useEffect(() => {
    if (!unsavedChanges) return;

    const handleBeforeUnload = event => {
      event.preventDefault();
      event.returnValue = '';
      return '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload, {
      capture: true
    });
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload, {
        capture: true
      });
    };
  }, [unsavedChanges]);

  useEffect(() => {
    setUnsavedChanges(hasUnsavedChanges());
    // const apiData =  request.get(`/productCatalog`).then(response => console.log(response,'my response'));
  }, [fullyManagedAdminData]);

  return (
    isLoading ? (
        <ValidateLoader
        message="Please wait request is In progress...."
        isFormStep={isLoading}
      />
    //   <p>Loading Data</p>
    ) : (
      <>
      {savingData && (
        <GroupOverlayCenter>
          <GroupOverlayInner>
            <ValidateLoader
                message="Please wait request is In progress...."
                isFormStep={savingData}
            />
          </GroupOverlayInner>
        </GroupOverlayCenter>
      )}
        {fullyManagedAdminData.map((groupItem, index) => (
          <ServiceGroup
            key={groupItem.id}
            offeringId={offeringId}
            groupData={groupItem}
            groupIndex={index}
            setSavingData={setSavingData}
            fullyManagedAdminData={fullyManagedAdminData}
            setFullyManagedAdminData={setFullyManagedAdminData}
          />
        ))}
        <hr />
        <ButtonLight onClick={handleAddCategory}>
          <AddSVG size={18} />
          Add category
        </ButtonLight>
      </>
    )
  );
  
}
